import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings"

const fieldsConfig = {
    modifyViews : {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : false,
        options         : [true, false]
    },
}

export default class ProjectAccessReadonlySettings extends ServerSettings {

    public modifyViews          : boolean

    constructor(config:any) {

        super(config, fieldsConfig)

        this.modifyViews            = this.initValue('modifyViews')
    }

    toJson() {
        const result = {}

        this.valueToJson(result, 'modifyViews')

        return result
    }
}